<header class="go-page-title">
  <h1 class="go-heading-1">{{ pageTitle }}</h1>
  <a
  [href]="linkToSource"
  target="_blank">
    <go-button buttonVariant="neutral"> View on GitHub </go-button>
  </a>
</header>

<div class="go-container">
  <go-card class="go-column go-column--100" id="usage">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Usage</h2>
      <go-copy cardId="usage" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <!-- Intro -->
        <p class="go-body-copy">
          The <code class="code-block--inline">&lt;go-icon&gt;</code>
          component should be the only way an icon is displayed in the
          app.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <!-- Bindings -->
        <h3 class="go-heading-3">Bindings</h3>
        <code [highlight]="componentBindings"></code>
      </div>

      <div class="go-column go-column--100">
        <h4 class="go-heading-4">icon - (required)</h4>
        <p class="go-body-copy">
          The <code class="code-block--inline">icon</code>
          binding must be passed. This component requires the
          <a class="go-link" href="https://google.github.io/material-design-icons/#setup-method-1-using-via-google-web-fonts">
            Material Icons Font
          </a>
          to be included in the application. To use, just pass the name
          of the icon to this binding.
        </p>
        <p class="go-body-copy">
          See the <a class="go-link" href="https://material.io/tools/icons/">Material Design System Icons</a>
          page for available icons.
        </p>
        <p class="go-body-copy go-body-copy--no-margin">
          See the full <a class="go-link" href="https://google.github.io/material-design-icons/">Material Icons Developer Guide</a>
          for more information.
        </p>
      </div>

      <div class="go-column go-column--100">
        <h4 class="go-heading-4">iconModifier</h4>
        <p class="go-body-copy">
          The <code class="code-block--inline">iconModifier</code> binding accepts a value of 
          <code class="code-block--inline">'light'</code>, <code class="code-block--inline">'dark'</code>, 
          <code class="code-block--inline">'positive'</code>, <code class="code-block--inline">'negative'</code>, 
          or <code class="code-block--inline">'neutral'</code>
          and will modify the icon color. The icon will inherit its color otherwise.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <h4 class="go-heading-4">iconClass</h4>
        <p class="go-body-copy go=go-body-copy--no-margin">
          The <code class="code-block--inline">iconClass</code>
          binding can be used to add additional classes directly
          on to the icon element inside of the component. This
          becomes useful when implementing icons inside of other
          components and especially when following the
          <a class="go-link" href="https://en.bem.info/methodology/">BEM methodology</a>
          This allows us to hand off the responsibility of modifying
          the icons to the thing that is implementing them.
        </p>
      </div>
    </div>
  </go-card>

  <go-card class="go-column go-column--100" id="basic">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Basic</h2>
      <go-copy cardId="basic" goCopyCardLink></go-copy>
    </ng-container>
    <ng-container go-card-content>
      <h4 class="go-heading-4">Code</h4>
      <code [highlight]="basicExample"></code>
      <h4 class="go-heading-4">View</h4>
      <go-icon icon="home"></go-icon>
      <go-icon icon="delete"></go-icon>
      <go-icon icon="info"></go-icon>
      <go-icon icon="done_all"></go-icon>
    </ng-container>
  </go-card>

  <go-card class="go-column go-column--100" id="modified">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Modified</h2>
      <go-copy cardId="modified" goCopyCardLink></go-copy>
    </ng-container>
    <ng-container go-card-content>
      <h4 class="go-heading-4">Code</h4>
      <code [highlight]="modifiedExample"></code>
      <h4 class="go-heading-4">View</h4>
      <go-icon icon="home" iconModifier="light" class="dark-example-area"></go-icon>
      <go-icon icon="home" iconModifier="dark"></go-icon>
      <go-icon icon="check" iconModifier="positive"></go-icon>
      <go-icon icon="close" iconModifier="negative"></go-icon>
      <go-icon icon="help" iconModifier="neutral"></go-icon>
    </ng-container>
  </go-card>
  
  <go-toast class="go-column go-column--100" type="negative" header="Wait!" [message]="iconOverrideWarning"></go-toast>

  <go-card class="go-column go-column--100" id="overriding-icon-styles">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Overriding Icon Styles</h2>
      <go-copy cardId="overriding-icon-styles" goCopyCardLink></go-copy>
    </ng-container>
    <ng-container go-card-content>
      <h4 class="go-heading-4">component.scss</h4>
      <code [highlight]="overriddenStyles"></code>
      <h4 class="go-heading-4">component.html</h4>
      <code [highlight]="overriddenExample"></code>
      <h4 class="go-heading-4">View</h4>
      <ul class="list">
        <li>
          <go-icon icon="face" iconClass="list__icon" iconModifier="positive"></go-icon>
          Face
        </li>
        <li>
          <go-icon icon="toys" iconClass="list__icon"></go-icon>
          Toys
        </li>
      </ul>
    </ng-container>
  </go-card>
</div>
